const intersectionObserverCallback = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
  entries.forEach((entry, index) => {

    if (entry.intersectionRatio  > .8) {
      requestAnimationFrame(() => {
        entry.target.classList.remove("crafted-anim-slider-element---fade");
      })
    } else if (entry.intersectionRatio  < .3) {
      requestAnimationFrame(() => {
        entry.target.classList.add("crafted-anim-slider-element---fade");
      })
    }

  })
}

const options: IntersectionObserverOptions = {
  root: null, // viewport
  rootMargin: "4000px 0px 4000px 0px",
  threshold: [.2, .9]
}

export default new IntersectionObserver(intersectionObserverCallback, options);
